import type { TenantUsageTypeLabelKeys } from 'ComponentLibrary/src/common/tenant'
import type { TenantBreakdownTableCopy } from 'ComponentLibrary/src/widgets/TenantTables/TenantSummaryTables/TenantBreakdownTable'
import type { TFunction } from 'i18next'

const tenantUsageTypeKeys = [
    'residential',
    'commercial',
    'gastronomy',
    'industry',
    'hotel',
    'storage',
    'underground_parking',
    'leisure',
    'social',
    'archive',
    'outdoor_parking',
    'parking',
    'retail',
    'logistics',
    'office',
    'other',
    'total',
    'other_parking',
    'open_space',
    'other_use',
    'garage_parking',
] as const satisfies TenantUsageTypeLabelKeys[]

const getTenantUsageTypeLabels = (tCommon: TFunction): Record<TenantUsageTypeLabelKeys, string> =>
    Object.fromEntries(tenantUsageTypeKeys.map((key) => [key, tCommon(`tenantUsageTypes.${key}`)])) as Record<
        TenantUsageTypeLabelKeys,
        string
    >

export const getTenantBreakdownTableCopy = (tCommon: TFunction, tTenantBreakdownTable: TFunction): TenantBreakdownTableCopy => ({
    headers: {
        usageType: tCommon('usageType'),
        areaAndUnits: tTenantBreakdownTable('headers.areaAndUnits'),
        vacancy: tTenantBreakdownTable('headers.vacancy'),
        contractRent: tCommon('contractRent'),
        marketRent: tCommon('marketRent'),
        delta: tTenantBreakdownTable('headers.delta'),
    },
    usageTypeLabels: getTenantUsageTypeLabels(tCommon),
    getUnitLabel: (count, isParking) =>
        isParking ? tTenantBreakdownTable('units.parkingSpace', { count }) : tTenantBreakdownTable('units.unit', { count }),
    monetaryUnits: {
        perYear: tTenantBreakdownTable('monetaryUnits.perYear'),
        perSquareMeterPerMonth: tTenantBreakdownTable('monetaryUnits.perSquareMeterPerMonth'),
        perUnitPerMonth: tTenantBreakdownTable('monetaryUnits.perUnitPerMonth'),
        perParkingSpacePerMonth: tTenantBreakdownTable('monetaryUnits.perParkingSpacePerMonth'),
    },
    empty: tTenantBreakdownTable('empty'),
})
